import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { initGA } from "./analytics";
const root = ReactDOM.createRoot(document.getElementById("root"));
initGA();
root.render(
  <>
    <ToastContainer
      position="top-right"
      autoClose={5000}
      theme="colored"
      pauseOnHover={false}
      draggable={false}
    />
    <App />
  </>
);
reportWebVitals();
